import { BaseHandler } from "../../infrastructure/base-handlers";
import { setSearchString } from "./actions";
import { SearchActivityHistoryItems } from "./request";

export class SearchItemsHandler extends BaseHandler {
  async handle(request: SearchActivityHistoryItems) {
    try {
      this.store.dispatch(setSearchString(request.searchString));
      setTimeout(() => {
        this.api.broker.publish(this.api.broker.events.activityHistory.searched, {
          searchQuery: request.searchString,
        });
      }, 300);
    } catch (e) {
      console.error(e.message);
    }
  }
}
